import { ActionIcon, Flex, Text } from '@mantine/core';
import { VoucherType } from '@prisma/client';
import { COLORS, ICON_STYLES, VOUCHER_TYPE_AMOUNTS } from './constants';
import { copyToClipboard } from './utils';
import { useTranslation } from 'react-i18next';
import { MyIcon } from '@web/common-ui';

export interface VoucherCodeProps {
  code: string;
  type: VoucherType;
}

export const VoucherCode = ({ code, type }: VoucherCodeProps) => {
  const { t } = useTranslation('questionnaire');
  const amount = VOUCHER_TYPE_AMOUNTS[type];

  return (
    <Flex justify="space-between" align="center">
      <Flex align="center">
        <Text size="16px" fw="400" c={COLORS.SUCCESS} lh="24px">
          {code}
        </Text>
        <ActionIcon
          variant="transparent"
          radius="xl"
          size="md"
          onClick={() => void copyToClipboard(code, t('VoucherCodeCopied'))}
          disabled={!code}
        >
          <MyIcon
            name="copy"
            style={{ fill: COLORS.SUCCESS, ...ICON_STYLES.medium }}
          />
        </ActionIcon>
      </Flex>
      {amount && (
        <Flex gap="4px" align="center">
          <Text size="16px" fw="400" c={COLORS.SUCCESS} lh="18px">
            {amount}
          </Text>
          <MyIcon
            name="redeem"
            style={{
              ...ICON_STYLES.small,
              fill: COLORS.SUCCESS,
            }}
          />
        </Flex>
      )}
    </Flex>
  );
};
